export {
  default as poolBasketballHoop,
  ReactComponent as PoolBasketballHoop,
} from '@assets/icons/features-and-amenities/pool-basketball-hoop.svg'    
